import { CloseIcon } from "@cynthai/icons";
import type { ReactNode } from "react";
import { memo, useCallback } from "react";

import Button from "../Button";

interface SelectChipProps {
  readonly label: string;
  readonly icon?: ReactNode;
  readonly badge?: ReactNode;
  readonly isDisabled?: boolean;
  readonly onRemove: () => void;
}

export const SelectChip = memo(function SelectChip({
  label,
  icon,
  badge,
  isDisabled = false,
  onRemove,
}: SelectChipProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onRemove();
    },
    [onRemove],
  );

  return (
    <div
      className={`bg-primary/5 text-primary/80 inline-flex items-center gap-2 rounded-lg px-4 py-0.5 text-sm`}
    >
      {icon}
      <span className="truncate">{label}</span>
      {badge}
      <Button
        onClick={handleClick}
        isDisabled={isDisabled}
        className={`hover:bg-primary/10 flex shrink-0 items-center justify-center rounded-full p-0 transition-colors`}
        aria-label={`Remove ${label}`}
      >
        <CloseIcon width={16} height={16} />
      </Button>
    </div>
  );
});
